import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3604314d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 1,
  class: "map-callout-card__address map-callout-card__address--empty"
}
const _hoisted_4 = { class: "map-callout-card__header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "map-callout-card__dot" }, null, -1))
const _hoisted_6 = { class: "map-callout-card__name" }
const _hoisted_7 = {
  key: 0,
  class: "map-callout-card__stats"
}
const _hoisted_8 = { class: "map-callout-card__stat" }

import { computed } from 'vue';
import type { DashboardMapItem } from '@/core/interfaces/Dashboard';
import type { CalloutRect } from '@/core/services/mapCalloutLayout.service';
import type { CalloutMode } from '@/core/constants/dashboard-map.constants';
import { MAP_MARKER_STATUS_COLORS } from '@/core/constants/dashboard-map.constants';
import { formatAmount } from '@/core/helpers/number-format';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapEntityCalloutCard',
  props: {
    marker: {},
    card: {},
    displayMode: { default: 'compact' },
    selected: { type: Boolean, default: false },
    hovered: { type: Boolean, default: false },
    showFinancial: { type: Boolean, default: true }
  },
  emits: ["select", "mouseenter", "mouseleave"],
  setup(__props: any) {

const props = __props;



const statusColor = computed(
  () =>
    MAP_MARKER_STATUS_COLORS[props.marker.status] ??
    MAP_MARKER_STATUS_COLORS.healthy
);

const isLabelOnly = computed(
  () => props.displayMode === 'label-only' && !props.selected && !props.hovered
);

/** Always use full entity name from map API. */
const displayName = computed(() => props.marker.name);

const style = computed(() => ({
  left: `${props.card.left}px`,
  top: `${props.card.top}px`,
  width: `${props.card.width}px`,
  minHeight: `${props.card.height}px`,
  '--status-color': statusColor.value,
}));

const inventoryDisplay = computed(() => {
  if (!props.showFinancial) {
    return '—';
  }
  return (
    props.marker.formattedInventoryAmount ??
    formatAmount(props.marker.inventoryAmount)
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["map-callout-card", [
      `map-callout-card--${_ctx.marker.status}`,
      {
        'is-selected': _ctx.selected,
        'is-hovered': _ctx.hovered,
        'is-label-only': isLabelOnly.value,
      },
    ]]),
    style: _normalizeStyle(style.value),
    title: _ctx.marker.name,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('select', _ctx.marker)), ["stop"])),
    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('mouseenter', _ctx.marker))),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('mouseleave', _ctx.marker)))
  }, [
    (_ctx.hovered)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.marker.address)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "map-callout-card__address",
                title: _ctx.marker.address
              }, _toDisplayString(_ctx.marker.address), 9, _hoisted_2))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, " Chưa có địa chỉ "))
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(displayName.value), 1)
          ]),
          (!isLabelOnly.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(inventoryDisplay.value), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ], 46, _hoisted_1))
}
}

})